import { render } from "./BlockCollectorEdit.vue?vue&type=template&id=c8a01aaa"
import script from "./BlockCollectorEdit.vue?vue&type=script&lang=js"
export * from "./BlockCollectorEdit.vue?vue&type=script&lang=js"
script.render = render

export default script